import React from 'react';
import { Spin, Progress } from 'antd';
import styles from './Common.module.css';

/**
 * Global component for displaying data fetching progress.
 * Intended to be controlled via LoadingContext.
 * 
 * @param {Object} props
 * @param {boolean} props.visible - Whether the screen is currently active
 * @param {number} props.percentage - The progress value (0 to 100)
 * @param {string} props.text - Descriptive text (e.g. "Caricamento Dati...")
 */
const DataLoadingScreen = ({ 
  visible = false, 
  percentage = null, 
  text = "Caricamento in corso..." 
}) => {
  if (!visible) return null;

  return (
    <div className={styles.dataLoaderOverlay}>
      <div className={styles.dataLoaderCard}>
        
        {/* Antd Spinner + Text */}
        <div className={styles.dataLoaderHeader}>
          <Spin size="large" />
          <h3 className={styles.dataLoaderText}>{text}</h3>
        </div>

        {/* Conditional Progress Bar */}
        {percentage !== null && (
          <div className={styles.dataLoaderProgress}>
            <Progress 
              percent={percentage} 
              status="active" 
              strokeColor={{
                '0%': '#A1E430',
                '100%': '#8BC92A',
              }}
              trailColor="rgba(255, 255, 255, 0.1)"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DataLoadingScreen;
